import axiosApiClient from "../axios";

const PATH = '/api/staff';

export const getAllStaff = async () => {
    try {
        return await axiosApiClient.get(PATH);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all staff');
    }
};

export const getStaffById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get staff by ID');
    }
};

export const getStaffByUsername = async (username) => {
    try {
        return await axiosApiClient.get(`${PATH}/username/${username}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get staff by username');
    }
};

export const createStaff = async (staffData) => {
    try {
        return await axiosApiClient.post(PATH, staffData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to create staff');
    }
};

export const updateStaff = async (staffId, staffData) => {
    try {
        return await axiosApiClient.put(`${PATH}/${staffId}`, staffData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to update staff');
    }
};

export const deleteStaff = async (staffId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${staffId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to delete staff');
    }
};

export const getStaffByBranchId = async (branchId) => {
    try {
        return await axiosApiClient.get(`${PATH}/branch/${branchId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get staff by branch ID');
    }
};

// Staff Image Management
export const getStaffImages = async (staffId) => {
    try {
        return await axiosApiClient.get(`${PATH}/${staffId}/images`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get staff images');
    }
};

export const uploadStaffImages = async (staffId, formData) => {
    try {
        return await axiosApiClient.post(`${PATH}/${staffId}/images`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to upload staff images');
    }
};

export const deleteStaffImage = async (staffId, imageId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${staffId}/images/${imageId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to delete staff image');
    }
};

// Staff Image API (direct endpoints)
export const getAllStaffImages = async () => {
    try {
        return await axiosApiClient.get('/api/staff-image');
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all staff images');
    }
};

export const getStaffImageById = async (imageId) => {
    try {
        return await axiosApiClient.get(`/api/staff-image/${imageId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get staff image');
    }
};

export const getStaffImagesByStaffId = async (staffId) => {
    try {
        return await axiosApiClient.get(`/api/staff-image/staff/${staffId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get staff images by staff ID');
    }
};

export const createStaffImage = async (imageData) => {
    try {
        return await axiosApiClient.post('/api/staff-image', imageData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to create staff image');
    }
};

export const deleteStaffImageById = async (imageId) => {
    try {
        return await axiosApiClient.delete(`/api/staff-image/${imageId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to delete staff image');
    }
};

const staffApiClient = {
    getAllStaff,
    getStaffById,
    getStaffByUsername,
    createStaff,
    updateStaff,
    deleteStaff,
    getStaffByBranchId,
    getStaffImages,
    uploadStaffImages,
    deleteStaffImage,
    getAllStaffImages,
    getStaffImageById,
    getStaffImagesByStaffId,
    createStaffImage,
    deleteStaffImageById
};

export default staffApiClient;
